import React from "react";
import {
  Button,
  Modal,
  // ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import DeleteIcon from "../../images/delete_img.png";

function ConfirmModal(props) {
  return (
    <Modal
      isOpen={props.confirmModal}
      toggle={props.confirmModaltoggle}
      size="md"
      centered
    >
      {/* <ModalHeader toggle={props.confirmModaltoggle}></ModalHeader> */}
      <ModalBody>
        <div className="deleteWrp">
          <img src={DeleteIcon} alt="delete icon" />
          <h2>Are You Sure ?</h2>
          <p>
            You're about to delete an item. Double-check your
            decision, as this action is irreversible.
          </p>{" "}
        </div>
      </ModalBody>
      <ModalFooter className="centerBtn">
        <Button
          color="primary"
          onClick={() => props.onProceed(props.passwordId)}
        >
          Proceed
        </Button>
        <Button color="outline" onClick={props.confirmModaltoggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ConfirmModal;
